import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-reset-pwd',
    templateUrl: './reset-pwd.component.html',
    styleUrls: ['./reset-pwd.component.css'],
    standalone: false
})
export class ResetPwdComponent implements OnInit {
  userName: string
  otp: string;
  newPassword: string;
  repeatPassword: string;
  serverErrorMessages: string;
  successMessage: string;
  constructor(private loginservice: LoginService, private router: Router) { }

  ngOnInit(): void {

  }

  onSubmit(form){
   //console.log('Inside ResetPwd',form.value);
    this.loginservice.resetPassword({userName: form.value.userName, otp: form.value.otp, newPassword: form.value.newPassword}).subscribe(
      data => {
       //console.log('Success');
        this.successMessage = data.message;
        setTimeout(() => {
          this.router.navigateByUrl('signin');
        }, 3000);
      },
      err => {
       //console.log('Error', err);
        this.serverErrorMessages = err.error.message
      }
    )
  }

}
